export * from './verify-account.component';
